export const PROFILE_COMPLETION_THRESHOLD = 60;

export const hasJobseekerResume = (user) => Boolean(user?.resume);

export const hasJobseekerBasics = (user) =>
  Boolean(user?.name && user?.mobile);

/** Can browse jobs — old users with resume, or profile already strong enough */
export const canJobseekerBrowseJobs = (user, completionPercentage) => {
  if (!user) return false;

  const pct = Number(completionPercentage) || 0;

  // Legacy users: resume already uploaded before onboarding existed
  if (hasJobseekerResume(user)) return true;

  // Finished the new onboarding wizard
  if (user.onboarding_completed) return true;

  // Legacy users with a solid profile (no onboarding flag needed)
  if (pct >= PROFILE_COMPLETION_THRESHOLD && hasJobseekerBasics(user)) {
    return true;
  }

  return false;
};

/** Show /jobseeker/onboarding only when profile still needs setup */
export const needsJobseekerOnboarding = (user, completionPercentage) => {
  if (!user) return false;
  return !canJobseekerBrowseJobs(user, completionPercentage);
};

export const getJobseekerPostAuthPath = (user, completionPercentage) => {
  if (needsJobseekerOnboarding(user, completionPercentage)) {
    return "/jobseeker/onboarding";
  }
  return "/jobs";
};
